var render = function render(){var _vm=this,_c=_vm._self._c;return _c('attr-' + _vm.editActiveElement.elName,_vm._b({tag:"component"},'component',{..._vm.editActiveElement.commonStyle, ..._vm.editActiveElement.propsValue},false))
}
var staticRenderFns = []

export { render, staticRenderFns }